export function BulkSelectCheckbox({
  checked,
  onChange,
  label,
  showLabel = false,
}: {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  showLabel?: boolean
}) {
  return (
    <label
      className="inline-flex items-center gap-2 text-xs font-medium"
      onClick={(event) => event.stopPropagation()}
    >
      <input
        type="checkbox"
        aria-label={label}
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="h-4 w-4 rounded border-border text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      />
      <span className={showLabel ? undefined : 'sr-only'}>{label}</span>
    </label>
  )
}
